import { PageHeaderWrapper } from '@ui';
import styled from 'styled-components';

export const CreateProviderSC = styled(PageHeaderWrapper)`
  .page-children {
    max-width: 808px;

    .ui-textfield,
    .ui-select,
    .ui-textarea {
      width: 100%;
    }

    .first-section {
      margin-top: 0px;
    }
  }
` as typeof PageHeaderWrapper;
